/* HABYS – parameter comparison table (built from product "Produktdetails" metafield) */
(function () {
  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var T = lang === 'nl'
    ? { label: 'Specificaties', price: 'Prijs', brand: 'Merk', warranty: 'Garantie', variants: 'Varianten', none: '–', years: 'jaar', sku: 'Artikelnummer' }
    : { label: 'Parameter', price: 'Preis', brand: 'Marke', warranty: 'Garantie', variants: 'Varianten', none: '–', years: 'Jahre', sku: 'Artikelnummer' };

  function norm(l) {
    return l.toLowerCase().replace(/\(.*?\)/g, '').replace(/[^a-z0-9äöüß]+/g, '');
  }

  function parseSpecs(el) {
    var out = [];
    if (!el) return out;
    el.querySelectorAll('li, p').forEach(function (li) {
      var txt = li.textContent.replace(/\s+/g, ' ').trim();
      var i = txt.indexOf(':');
      if (i < 1 || i > 80) return;
      var label = txt.slice(0, i).trim();
      var value = txt.slice(i + 1).trim();
      if (!value) return;
      out.push({ key: norm(label), label: label, value: value });
    });
    return out;
  }

  function build(area) {
    if (area.dataset.hpcDone === '1') return;
    var titleCols = area.querySelectorAll('[data-compare-key="compare-title"]');
    if (!titleCols.length) return;
    var products = [];
    titleCols.forEach(function (col) {
      var idClass = Array.prototype.find.call(col.classList, function (c) { return /^compare-col--\d+$/.test(c); });
      var data = col.querySelector('.hpc-data');
      products.push({
        cls: col.className,
        id: idClass,
        specs: parseSpecs(data && data.querySelector('.hpc-specs')),
        brand: data ? data.getAttribute('data-brand') : '',
        warranty: data ? data.getAttribute('data-warranty') : '',
        sku: data ? data.getAttribute('data-sku') : ''
      });
    });

    // union of parameters, ordered by how many products have them, then by first appearance
    var order = [], meta = {};
    products.forEach(function (p, pi) {
      p.map = {};
      p.specs.forEach(function (s, si) {
        p.map[s.key] = s.value;
        if (!meta[s.key]) { meta[s.key] = { label: s.label.replace(/[:：*\s]+$/, ''), count: 0, first: pi * 100 + si }; order.push(s.key); }
        meta[s.key].count++;
      });
    });
    if (products.length > 1) {
      order.sort(function (a, b) { return (meta[b].count - meta[a].count) || (meta[a].first - meta[b].first); });
    }

    var rows = [];
    if (!meta['marke']) rows.push({ label: T.brand, vals: products.map(function (p) { return p.brand || T.none; }) });
    rows.push({ label: T.warranty, vals: products.map(function (p) { return p.warranty || T.none; }), strong: true });
    order.forEach(function (k) {
      rows.push({ label: meta[k].label, vals: products.map(function (p) { return p.map[k] || T.none; }) });
    });
    rows.push({ label: T.sku, vals: products.map(function (p) { return p.sku || T.none; }), muted: true });

    // remove theme's old metafield rows
    area.querySelectorAll('.compare-row--metafield').forEach(function (r) { r.remove(); });

    // insert new rows after the price row
    var priceRow = area.querySelector('[data-compare-key="compare-price"]');
    var anchor = priceRow ? priceRow.parentElement : null;
    var frag = document.createDocumentFragment();
    rows.forEach(function (r) {
      var row = document.createElement('div');
      row.className = 'compare-row compare-row--hpc';
      var lab = document.createElement('div');
      lab.className = 'hpc-label';
      lab.textContent = r.label;
      row.appendChild(lab);
      products.forEach(function (p, i) {
        var c = document.createElement('div');
        c.className = 'compare-col compare-col--medium ' + (p.id || '') + ' hpc-cell' + (r.strong ? ' is-strong' : '') + (r.muted ? ' is-muted' : '') + (r.vals[i] === T.none ? ' is-empty' : '');
        c.textContent = r.vals[i];
        row.appendChild(c);
      });
      frag.appendChild(row);
    });
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(frag, anchor.nextSibling);

    // label column for the theme rows (image, title, price, variants, actions)
    area.querySelectorAll('.compare-row:not(.compare-row--hpc)').forEach(function (row) {
      if (row.querySelector(':scope > .hpc-label')) return;
      var key = (row.firstElementChild && row.firstElementChild.getAttribute('data-compare-key')) || '';
      var lab = document.createElement('div');
      lab.className = 'hpc-label hpc-label--blank';
      if (key === 'compare-price') { lab.textContent = T.price; lab.classList.remove('hpc-label--blank'); }
      if (key === 'compare-variants') { lab.textContent = T.variants; lab.classList.remove('hpc-label--blank'); }
      if (key === 'compare-image') { lab.textContent = T.label; lab.classList.add('hpc-label--head'); }
      row.insertBefore(lab, row.firstChild);
    });
    area.classList.add('hpc-table');
    area.dataset.hpcDone = '1';
  }

  function scan() {
    document.querySelectorAll('.js-compare-area').forEach(function (a) {
      if (a.querySelector('[data-compare-key="compare-title"]')) build(a);
    });
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.closest && t.closest('.js-compare-area')) {
        var a = t.closest('.js-compare-area');
        // content was replaced → rebuild
        if (!a.querySelector('.compare-row--hpc')) a.dataset.hpcDone = '';
      }
    }
    clearTimeout(window.__hpcT);
    window.__hpcT = setTimeout(scan, 120);
  });
  document.addEventListener('DOMContentLoaded', function () {
    mo.observe(document.body, { childList: true, subtree: true });
    scan();
  });
})();
